import React from "react";
import { Fab, Tooltip } from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";
import { useCopilot } from "../CopilotProvider";
import { ChatBotIcon } from "@hugeicons/core-free-icons";

const CopilotFAB: React.FC = () => {
  const { toggleDrawer } = useCopilot();

  return (
    <Tooltip title="Hablar con tu asistente" placement="right">
      <Fab
        color="primary"
        aria-label="asistente"
        onClick={toggleDrawer}
        sx={{
          position: "absolute",
          bottom: 24,
          right: 24,
          zIndex: 1200,
        }}
      >
        <HugeiconsIcon icon={ChatBotIcon} color="white" size={32} />
      </Fab>
    </Tooltip>
  );
};

export default CopilotFAB;
